import { mock } from "../../conf/context";
import ajax from "../../lib/appfuse-react/core/ajax";
import {setAuthenticated, setToken} from "../../reducer/iam/authReducer";
import store from "../../store";

const authService = {
    login: async (authorization) => {
        let response;
        try {
            response = await ajax.get('login', {}, {
                authorization: authorization
            });
            if(response.authorization) {
                store.dispatch(setToken(response.authorization));
                store.dispatch(setAuthenticated(true));
            }
        } catch(e) {
            store.dispatch(setToken(null));
            store.dispatch(setAuthenticated(false));
            throw e;
        }

        return response.data;
    },
    logout: () => {
        ajax.authorization = undefined; //登出時同時清除ajax.authorization
        store.dispatch(setToken(null));
        store.dispatch(setAuthenticated(false));
    },
    fetchApplets: async () => {
        const response = await mock.get('applets');
        return response.data;
    },
    forgotPassword: (username) => {

    },
    verify: async (token, pin) => {
        const authorization = `Bearer ${token}`;
        const response = await ajax.get('login', {}, {
            authorization: authorization,
            headers: {pin}
        });
        if(response.authorization) {
            store.dispatch(setToken(response.authorization));
            store.dispatch(setAuthenticated(true));
        }
    },
    fetchUserInfo: async (authorization) => {
        const response = await mock.get('userInfo', {},{
            authorization: authorization
        });
        return response.data;
    }
}

export default authService;